export const changeFolderCountText = "kE8lXd";
export const showUnreadCountText = "gFDYtb";
export const showTotalCountText = "n8imhb";
export default {changeFolderCountText,showUnreadCountText,showTotalCountText};